// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
  :host {
    position: absolute;
  }
  .fab-menu {
      box-sizing: border-box;
      font-size: 12px;
      width:40px;
      height: 40px;
      text-align: left;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      z-index: 9;
  }
  .fab-toggle {
    border-radius: 100%;
    width: 36px;
    height: 36px;
    color: white;
    text-align: center;
    line-height: 50px;
    transform: translate3d(0, 0, 0);
    transition: all ease-out 200ms;
    z-index: 2;
    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    transition-duration: 400ms;
    transform: scale(1, 1) translate3d(0, 0, 0);
    cursor: pointer;
    box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);
  }
  .fab-menu .fab-toggle:hover {
    transform: scale(1.2, 1.2) translate3d(0, 0, 0);
  }
  .fab-menu ::ng-deep .item {
     opacity: 0;
  }
  .fab-menu.active ::ng-deep .item {
     opacity: 1;
  }
  .fab-menu.active ::ng-deep .content-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .fab-menu.active ::ng-deep .content {
    display: block;
  }
  .fab-menu.active .fab-toggle {
    transition-timing-function: linear;
    transition-duration: 200ms;
    transform: scale(1, 1) translate3d(0, 0, 0);
  }
  `, "",{"version":3,"sources":["webpack://./src/app/gui-helpers/fab-button/ngx-fab-button.component.ts"],"names":[],"mappings":";EACE;IACE,kBAAkB;EACpB;EACA;MACI,sBAAsB;MACtB,eAAe;MACf,UAAU;MACV,YAAY;MACZ,gBAAgB;MAChB,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,eAAe;MACf,UAAU;EACd;EACA;IACE,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,+BAA+B;IAC/B,8BAA8B;IAC9B,UAAU;IACV,mEAAmE;IACnE,0BAA0B;IAC1B,2CAA2C;IAC3C,eAAe;IACf,uCAAuC;EACzC;EACA;IACE,+CAA+C;EACjD;EACA;KACG,UAAU;EACb;EACA;KACG,UAAU;EACb;EACA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;EACA;IACE,cAAc;EAChB;EACA;IACE,kCAAkC;IAClC,0BAA0B;IAC1B,2CAA2C;EAC7C","sourcesContent":["\n  :host {\n    position: absolute;\n  }\n  .fab-menu {\n      box-sizing: border-box;\n      font-size: 12px;\n      width:40px;\n      height: 40px;\n      text-align: left;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      cursor: pointer;\n      z-index: 9;\n  }\n  .fab-toggle {\n    border-radius: 100%;\n    width: 36px;\n    height: 36px;\n    color: white;\n    text-align: center;\n    line-height: 50px;\n    transform: translate3d(0, 0, 0);\n    transition: all ease-out 200ms;\n    z-index: 2;\n    transition-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    transition-duration: 400ms;\n    transform: scale(1, 1) translate3d(0, 0, 0);\n    cursor: pointer;\n    box-shadow: 0 2px 5px 0 rgba(0,0,0,.26);\n  }\n  .fab-menu .fab-toggle:hover {\n    transform: scale(1.2, 1.2) translate3d(0, 0, 0);\n  }\n  .fab-menu ::ng-deep .item {\n     opacity: 0;\n  }\n  .fab-menu.active ::ng-deep .item {\n     opacity: 1;\n  }\n  .fab-menu.active ::ng-deep .content-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n  .fab-menu.active ::ng-deep .content {\n    display: block;\n  }\n  .fab-menu.active .fab-toggle {\n    transition-timing-function: linear;\n    transition-duration: 200ms;\n    transform: scale(1, 1) translate3d(0, 0, 0);\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
